export default __webpack_public_path__ + "static/0ce2e70012dca39162157a65289a7ef1.jpeg";